import { FormLabel, ListItem } from "@mui/material";
import { useContext, useState } from "react";
import { ComponentPropsContext, ComponentPropsContextApi } from "layouts/Flow Designer/context";
import SoftTypography from "components/SoftTypography";
import CreatableSoftSelect from "components/CreatableSoftSelect";

const styles = {
  w100: {
    width: "100%"
  },
  listItemMargin_t16: {
    marginTop: "16px"
  },
  asterisk: {
    color: "#ff667c"
  }
};

export const CreatableSelect = ({ action, fieldValue, allowEditWorkflow }) => {
  const { actionForm, formErrors } = useContext(ComponentPropsContext);
  const { setActionForm } = useContext(ComponentPropsContextApi);
  const [selectedValues, setSelectedValues] = useState([]);

  const handleOnChange = (selectedOptions, meta) => {
    if (meta.action === "create-option") {
      const createdOption = meta.option;

      // this means there are already created options with the new value
      if (
        selectedValues.some(
          (option) => option.value.toLowerCase().trim() === createdOption.value.toLowerCase().trim()
        )
      ) {
        return;
      }
    }

    const mappedValues = selectedOptions.map((option) => option.value);
    setActionForm({
      ...actionForm,
      [action.field]: {
        value: mappedValues
      }
    });
    setSelectedValues(selectedOptions);
  };

  const createOptions = () => {
    if (action.options?.length > 0) {
      return action.options.map((option) => ({
        value: option,
        label: option
      }));
    }
    return [];
  };

  const createValues = () => {
    if (Array.isArray(fieldValue))
      return fieldValue.map((value) => ({
        value,
        label: value
      }));

    return [];
  };

  return (
    <ListItem
      className={`simple-tag ${formErrors.includes(action.field) && "error"}`}
      sx={{ ...styles.w100, ...styles.listItemMargin_t16, display: "block" }}
    >
      <FormLabel sx={{ fontSize: "12px", paddingLeft: "12px", display: "block" }}>
        {action.label} {action.isRequired ? <span style={{ color: "#ff667c" }}>*</span> : ""}
      </FormLabel>
      <CreatableSoftSelect
        className="responsive-multi-height"
        placeholder="Select Integrations"
        options={createOptions()}
        isMulti={true}
        value={createValues()}
        sx={{ zIndex: 0 }}
        hideSelectedOptions={false}
        onChange={handleOnChange}
        menuPlacement="bottom"
        isDisabled={!allowEditWorkflow}
      />
      {formErrors.includes(action.field) && (
        <SoftTypography
          sx={{
            color: "#ff667c",
            fontSize: "12px"
          }}
        >
          {action.label} is required
        </SoftTypography>
      )}
    </ListItem>
  );
};
